import { render } from "./form-item.vue?vue&type=template&id=ce1f9458&lang=pug"
import script from "./form-item.vue?vue&type=script&lang=js"
export * from "./form-item.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__